export default {
  CONVERSATIONS: {
    CREATE_CONVERSATION: `Create conversation`,
    CONVERSATION_LIST: `Conversations`,
    SELECT_PARTICIPANTS: `Select participants`
  },
  CONVO: {
    SEND_MESSAGE: `Send message`,
    OWNER: `Owner`,
    IS_TYPING: `is typing...`,
    ARE_TYPING: `are typing...`,
    CUSTOM_NAME: `Custom name...`,
    DELETE_CONVERSATION: {
      TITLE: `Delete the conversation`,
      SUMMARY: `This action is irreversible, you will not be able to recover the conversation.`,
      PRIMARY_ACTION: `Delete conversation`
    },
    PARTICIPANTS: {
      TITLE: `Participants`,
      ADD: `Add`,
      REMOVE: `Remove`
    },
    MENU: {
      DELETE: `Delete`,
      MANAGE: `Manage participants`,
      RENAME: `Rename`
    }
  }
}
